module.exports = "/deep/ ul.list-mode > li .panel-body {\n  padding: 12px 25px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-plugin/list-plugin.component.scss
// module id = ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-plugin/list-plugin.component.scss
// module chunks = main